import React from "react";
import FooterOne from "./FooterOne";
import HeaderOne from "./HeaderOne";

const AboutUs = () => {

  document.title = "About Us | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container">
          <div className="row justify-center">
            <div className="col-12 col-lg-9">

              {/* <h2 className="mt-4 mb-3">About MordenBazaar</h2> */}
             <h1 className="display-6 fw-bold">
  About MordenBazaar @ FZ Signature Tools Private Limited
</h1>

              <br />
              <p className="text-large">
                Welcome to <strong>MordenBazaar</strong> — your trusted online destination for premium lifestyle products at the best prices.
              </p>
              <br />
              <p>
                At MordenBazaar, we believe shopping should be simple, elegant, and enjoyable.
                Our mission is to bring together a curated collection of high-quality products
                that match the needs of today’s morden shoppers.
              </p>
              <br />
              <p>
                From fashion to home essentials, we handpick items that blend 
                <strong> style, comfort, and everyday utility</strong>. With a seamless browsing experience, 
                secure checkout, and dedicated customer support, we ensure you enjoy a smooth 
                and satisfying shopping journey.
              </p>
              <br />
              <p>
                We are committed to offering authentic products, reliable delivery, and 
                excellent service. Our goal is to build a space where trust meets convenience, 
                and customers feel valued at every step.
              </p>

              <p>
                Thank you for choosing MordenBazaar — where smart shopping begins.
              </p>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default AboutUs;
